import { render, staticRenderFns } from "./logisticsDetail.vue?vue&type=template&id=fa41ed4c&scoped=true"
import script from "./logisticsDetail.vue?vue&type=script&lang=ts"
export * from "./logisticsDetail.vue?vue&type=script&lang=ts"
import style0 from "./logisticsDetail.vue?vue&type=style&index=0&id=fa41ed4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa41ed4c",
  null
  
)

export default component.exports